<template>
  <div class="create-loi-main" :style="{ backgroundColor: $store.state['backgroundColor'] }">
    <div class="left-section">
      <div class="current-name">{{ currentFile }}.json</div>
      <button class="left-button" @click="loadClicked(showSavedJsons ? 'C' : (currentFile == 'Untitled' ? 'L' : 'N'))">{{ showSavedJsons ? 'Cancel' : (currentFile == 'Untitled' ? 'Load File' : 'New File') }}</button>
      <button class="left-button" v-if="!showSavedJsons" @click="saveClicked">Save</button>

      <div v-if="!showSavedJsons">Main styling</div>
      <!-- <textarea v-model="mainStyle"></textarea> -->
      <!-- @change="styleOperations('pt', ti, -1, $event)" -->
      <div v-if="!showSavedJsons" class="text-container">Padding Top    : <input type="number" min="0" v-model="mainStyleObj['padding-top']">
Padding Right  : <input type="number" min="0" v-model="mainStyleObj['padding-right']">
Padding Bottom : <input type="number" min="0" v-model="mainStyleObj['padding-bottom']">
Padding Left   : <input type="number" min="0" v-model="mainStyleObj['padding-left']">
      </div>

      <div v-if="!showSavedJsons" class="all-texts">
        <div class="text-holder" v-for="(t, ti) in textLists" :key="ti" @mouseover="hover(ti)" @mouseout="hoverOut">
          <div class="text-buttons">
            <button @click="textOperation('goUp', ti)" :disabled="ti == 0">↑</button>
            <button @click="textOperation('goDown', ti)" :disabled="ti == textLists.length - 1">↓</button>
            <button class="delete" @click="textOperation('delete', ti)">×</button>
          </div>
          <div class="text-container" v-if="!t['child']">Margin Top    : <input type="number" min="0" v-model="t['styleObj']['margin-top']" @change="styleOperations('mt', ti, -1, $event)">
Margin Right  : <input type="number" min="0" v-model="t['styleObj']['margin-right']" @change="styleOperations('mr', ti, -1, $event)">
Margin Bottom : <input type="number" min="0" v-model="t['styleObj']['margin-bottom']" @change="styleOperations('mb', ti, -1, $event)">
Margin Left   : <input type="number" min="0" v-model="t['styleObj']['margin-left']" @change="styleOperations('ml', ti, -1, $event)"><br>

            <div class="styling-button">
              <button @click="styleOperations('B', ti, -1)">B</button>
              <button @click="styleOperations('U', ti, -1)">U</button>
              <button @click="styleOperations('I', ti, -1)">I</button>
              <button @click="styleOperations('AL', ti, -1)">
                <img src="https://dsmlib.logistics.systems/Icons/LeftAlign.png" height="15" alt="">
              </button>
              <button @click="styleOperations('AC', ti, -1)">
                <img src="https://dsmlib.logistics.systems/Icons/CenterAlign.png" height="15" alt="">
              </button>
              <button @click="styleOperations('AR', ti, -1)">
                <img src="https://dsmlib.logistics.systems/Icons/RightAlign.png" height="15" alt="">
              </button><br>
              <!-- Width <input type="number" @change="styleOperations('MW', ti, -1, $event)" v-model="t['styleObj']['min-width']"> -->
            </div>
            <input type="text" style="width: 100%" v-model="t['text']" placeholder="Text">
            <!-- <textarea v-model="t['text']"></textarea> -->
            <!-- <textarea v-model="t['style']" placeholder="Styling"></textarea> -->
          </div>
          <div v-else class="text-container">
            <div v-for="(c, ci) in t['child']" :key="ci">
              <div class="styling-button">
                <button @click="styleOperations('B', ti, ci)">B</button>
                <button @click="styleOperations('U', ti, ci)">U</button>
                <button @click="styleOperations('I', ti, ci)">I</button><br>
              <button @click="styleOperations('AL', ti, ci)">
                <img src="https://dsmlib.logistics.systems/Icons/LeftAlign.png" height="15" alt="">
              </button>
              <button @click="styleOperations('AC', ti, ci)">
                <img src="https://dsmlib.logistics.systems/Icons/CenterAlign.png" height="15" alt="">
              </button>
              <button @click="styleOperations('AR', ti, ci)">
                <img src="https://dsmlib.logistics.systems/Icons/RightAlign.png" height="15" alt="">
              </button><br>
                <span v-if="ci == 0">Width</span> <input type="number" v-if="ci == 0" @change="styleOperations('MW', ti, ci, $event)" v-model="c['styleObj']['min-width']">
              </div>
              <input type="text" style="width: 100%" v-model="c['text']" placeholder="Text">
              <!-- <textarea v-model="c['text']"></textarea> -->
              <!-- <textarea v-model="c['style']" placeholder="Styling"></textarea> -->
            </div>
          </div>
        </div>
  
        <button class="left-button" @click="addText">Add Text</button>
        <button class="left-button" @click="addTextWithColon">Add Text With Child</button>
        <button class="left-button" @click="addBlankSpace">Add Blank Space</button>
      </div>
      <div v-else class="saved-json">
        <div class="title">Load JSON</div>
        <div v-if="loadingJsons">Loading . . .</div>
        <div v-if="noAvailableJsons">No JSONs available</div>
        <div class="jsons" v-for="(s, i) in savedJson" :key="i">
          <div @click="loadJson(s)">{{ s }}</div>
          <img class="delete" @click="deleteJsonClicked(i)" src="https://dsmlib.logistics.systems/Icons/Delete.png" alt="">
        </div>
      </div>
    </div>

    <div class="right-section" ref="right-section">
      <div :style="mainStyle" class="holder">
        <div v-for="(t, ti) in textLists" :key="ti" :style="t['style']">
          <div v-if="!t['child']" style="white-space: pre-wrap; font-family: Arial, Helvetica, sans-serif;">{{ t['text'] }}</div>
          <div v-else style="display: flex">
            <div v-for="(c, ci) in t['child']" :style="c['style']" style="white-space: pre-wrap; font-family: Arial, Helvetica, sans-serif;" :key="ci">{{ c['text'] }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="right-toolbar">
      <button @click="zoomIn">+</button>
      <button @click="zoomOut">-</button>
      <div>{{ Math.floor(currentScale * 100) }}%</div>
    </div>

    <div v-if="showSave" class="show-save">
      <div class="content">
        <img src="https://dsmlib.logistics.systems/Icons/Cancel.png" class="close" @click="showSave = false; pdfPreview = null">
        <div class="title">Save as new file</div>
        <Input placeholder="File Name" :inputValue.sync="saveFileName" />
        <iframe v-if="pdfPreview" style="min-height: 500px" :src="pdfPreview" frameborder="0"></iframe>
        <div v-else>Loading Preview . . .</div>
        <div style="color: red; margin: 5px 0">Please make sure that your enter the name with exact match to the report type and same name will overwrite the old file.</div>
        <button @click="submit">Confirm</button>
      </div>
    </div>

    <div ref='testdiv' style='height: 1in; left: -100%; position: absolute; top: -100%; width: 1in;'></div>

    <PopupV2 :show="popupShow" :type="popupType" :title="popupTitle" :content="popupContent" :buttons="popupButtons" @buttonClicked="popupButtonClicked" />
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      a4height: 3508, // 300 dpi
      a4width: 2480, // 300 dpi

      screenDPI: 0,
      rightSection: null,
      a4Container: null,
      viewRatio: 0,
      viewFont: 0,

      mainStyleObj: {
        'display': 'flex',
        'flex-direction': 'column',
        // 'height': 'calc(100%)',
        'padding-top': '150',
        'padding-right': '30',
        'padding-bottom': '50',
        'padding-left': '30',
      },
      // mainStyle: 'display: flex; flex-direction: column; height: calc(100%); padding: 150px 30px 50px 30px',
      textLists: [],

      showSavedJsons: false,
      loadingJsons: false,
      noAvailableJsons: false,
      savedJson: [],

      hoverChild: null,

      addPXKey: [ 'min-width', 'margin-top', 'margin-right', 'margin-bottom', 'margin-left',
        'padding-top', 'padding-right', 'padding-bottom', 'padding-left' ],

      showSave: false,
      saveFileName: '',
      saveObject: null,
      pdfPreview: null,

      popupShow: false,
      popupType: '',
      popupTitle: '',
      popupContent: '',
      popupButtons: [],

      currentFile: 'Untitled',

      currentScale: 1,

      jsonToDelete: '',
    }
  },
  computed: {
    mainStyle: function() {
      return Object.entries(this.mainStyleObj).map(([k, v]) => `${k}:${v}${this.addPXKey.includes(k) ? 'px' : ''}`).join(';');
    }
  },
  props: {
  },
  methods: {
    addText: function() {
      this.textLists.push({ text: 'Text here', style: 'margin-top:0;margin-right:0;margin-bottom:0;margin-left:0', styleObj: {
        'margin-top': 0,
        'margin-right': 0,
        'margin-bottom': 0,
        'margin-left': 0,
      } })
    },
    addTextWithColon: function() {
      this.textLists.push({ text: '', style: '', styleObj: {}, child: [
        { text: 'Label', style: 'min-width:100px;', styleObj: { 'min-width': '100' } },
        { text: ':', style: 'min-width:10px;', styleObj: { 'min-width': '10' } },
        { text: 'Text', style: 'width:100%', styleObj: { width: '100%' } }
      ] })
    },
    addBlankSpace: function() {
      this.textLists.push({ text: '', style: 'height:100%', styleObj: {
        'margin-top': 0,
        'margin-right': 0,
        'margin-bottom': 0,
        'margin-left': 0,
        'height':'100%'
      } })
    },
    hover: function(index) {
      let parent = this.rightSection.children[0];
      this.hoverChild = parent.children[index];
      this.hoverChild.style.border = '1px solid black';
    },
    hoverOut: function() {
      if (this.hoverChild) {
        this.hoverChild.style.border = 'none';
      }
    },
    saveClicked: async function() {
      this.showSave = true;
      this.saveFileName = this.currentFile == 'Untitled' ? '' : this.currentFile;

      // let paddingOffset = parseInt(this.mainStyleObj['padding-top']) + parseInt(this.mainStyleObj['padding-bottom']);
      // let formattedStr = JSON.stringify(this.textLists);
      // let formatted = JSON.parse(formattedStr);

      // formatted.forEach(f => {
      //   if (f['child']) {
      //     f['child'][0]['styleObj']['min-width'] = parseInt(f['child'][0]['styleObj']['min-width']) * 1.2;
      //     f['child'][0]['style'] = Object.entries(f['child'][0]['styleObj']).map(([k,v]) => `${k}:${v}${this.addPXKey.includes(k) ? 'px' : ''}`).join(';');
      //   }
      // });

      this.saveObject = {
        headerLogo: '',
        // mainStyle: this.mainStyle,
        mainStyle: this.mainStyle.split('calc(100%)').join(``),
        data: this.textLists
        // data: formatted
      }

      let data = {
        template: { shortid: 'Tp1Zdc-h-C' },
        data: this.saveObject,
        options: { 'Content-Disposition': 'attachment;filename=report.pdf'}
      };
      let headerInfo = {
        'Content-Type': 'application/json',
        'Authorization': 'Basic YWRtaW46ZG1fNTU2OWRz'
      };
      try {
        let jsReportPDF = await this.$apiCallV2('https://dsm.logistics.systems:5488/api/report', data, { headers: headerInfo, responseType: 'arraybuffer' });
        let contentType = jsReportPDF.headers['content-type'];
        let pdfBlob = new Blob([ jsReportPDF.data ], { type: contentType });
        var url = window.URL.createObjectURL(pdfBlob, { oneTimeOnly: false });
        var link = document.createElement('a');
        link.href = url;
        this.pdfPreview = url;
      } catch(e) {
        console.log(e);
      }
    },
    submit: async function() {
      let toPost = this.saveObject;

      this.popupButtons = [];

      try { let saveFile = await this.$apiCallV2(`/LOI/SaveJson?file=${this.saveFileName}`, toPost); }
      catch {
        this.popupShow = true;
        this.popupType = 'error';
        this.popupTitle = 'Save Error';
        this.popupContent = 'There was an error saving your JSON, please try again later';
      }

      this.popupShow = true;
      this.popupType = 'success';
      this.popupTitle = 'Saved';
      this.popupContent = 'Successfully saved your format';

      this.currentFile = this.saveFileName;
      this.showSave = false;
    },
    textOperation: function(method, index) {
      let beforeIndex = index - 1;
      let toIndex = index + 1;

      switch (method) {
        case 'goUp':
          this.textLists.splice(beforeIndex, 0, this.textLists.splice(index, 1)[0]);
          break;
        case 'goDown':
          this.textLists.splice(toIndex, 0, this.textLists.splice(index, 1)[0]);
          break;
        case 'delete':
          this.textLists.splice(index, 1);
          break;
      }
    },
    styleOperations: function(method, index, childIndex, e) {
      let currentStyle = '';
      let addStyle = {};
      let key = '';

      switch (method) {
        case 'B':
          key = 'font-weight';
          addStyle['font-weight'] = 'bold';
          break;
        case 'U':
          key = 'text-decoration';
          addStyle['text-decoration'] = 'underline';
          break;
        case 'I':
          key = 'font-style';
          addStyle['font-style'] = 'italic';
          break;
        case 'AL':
          key = 'text-align';
          addStyle['text-align'] = 'left';
          break;
        case 'AC':
          key = 'text-align';
          addStyle['text-align'] = 'center';
          break;
        case 'AR':
          key = 'text-align';
          addStyle['text-align'] = 'right';
          break;
        case 'MW':
          key = 'min-width';
          addStyle['min-width'] = e.target.value;
          break;
        case 'mt':
          key = 'margin-top';
          addStyle['margin-top'] = e.target.value;
          break;
        case 'mr':
          key = 'margin-right';
          addStyle['margin-right'] = e.target.value;
          break;
        case 'mb':
          key = 'margin-bottom';
          addStyle['margin-bottom'] = e.target.value;
          break;
        case 'ml':
          key = 'margin-left';
          addStyle['margin-left'] = e.target.value;
          break;
      }

      if (childIndex >= 0) {
        currentStyle = this.textLists[index]['child'][childIndex]['styleObj'];

        if (key == 'min-width') {
          if (e.target.value) {
            currentStyle[key] = addStyle[key];    
          } else {
            delete currentStyle[key];    
          }
        } else {
          if (currentStyle[key]) {
            if (key != 'text-align') {
              delete currentStyle[key];
            } else {
              currentStyle[key] = addStyle[key];
            }
          } else {
            currentStyle[key] = addStyle[key];
          }
        }

        this.textLists[index]['child'][childIndex]['style'] = Object.entries(currentStyle).map(([k,v]) => `${k}:${v}${k == 'min-width' ? 'px' : ''}`).join(';');
      } else {
        currentStyle = this.textLists[index]['styleObj'];

        if (this.addPXKey.includes(key)) {
          if (e.target.value) {
            currentStyle[key] = addStyle[key];    
          } else {
            delete currentStyle[key];    
          }
        } else {
          if (currentStyle[key]) {
            if (key != 'text-align') {
              delete currentStyle[key];
            } else {
              currentStyle[key] = addStyle[key];
            }
          } else {
            currentStyle[key] = addStyle[key];
          }
        }

        this.textLists[index]['style'] = Object.entries(currentStyle).map(([k,v]) => `${k}:${v}${this.addPXKey.includes(k) ? 'px' : ''}`).join(';');
      }
    },

    zoomIn: function() {
      if (this.currentScale < 2) {
        this.currentScale += 0.1;
        this.zoom();
      }
    },
    zoomOut: function() {
      if (this.currentScale > 0.2) {
        this.currentScale -= 0.1;
        this.zoom();
      }
    },
    zoom: function() {
      this.currentScale = Math.round(this.currentScale * 10) / 10;
      this.a4Container.style['transform'] = `scale(${this.currentScale})`;

      if (this.currentScale > 1) {
        this.a4Container.style['transform-origin'] = `top left`;
      } else {
        this.a4Container.style['transform-origin'] = `center`;
      }

      // if (this.currentScale == 0.4) {
      //   let mywindow = window.open('', 'PRINT', 'height=400,width=600');

      //   // mywindow.document.write('<html><head><title>' + document.title  + '</title>');
      //   // mywindow.document.write('</head><body >');
      //   mywindow.document.write(`<html><body style="${this.mainStyle}">`);
      //   // mywindow.document.write('<h1>' + document.title  + '</h1>');
      //   mywindow.document.write(this.a4Container.innerHTML);
      //   mywindow.document.write('</body></html>');

      //   mywindow.document.close(); // necessary for IE >= 10
      //   mywindow.focus(); // necessary for IE >= 10*/

      //   mywindow.print();
      //   mywindow.close();

      //   return true;
      // }
    },

    popupButtonClicked: async function(btn) {
      this.popupShow = false;

      if (btn == 'Delete') {
        try {
          await this.$apiCallV2(`/LOI/DeleteJson?file=${this.jsonToDelete}`, null, 'delete');
          
          this.popupShow = true;
          this.popupType = 'success';
          this.popupTitle = 'JSON Deleted';
          this.popupContent = `${this.jsonToDelete} has been deleted.`;
          this.popupButtons = [];

          let index = this.savedJson.indexOf(this.jsonToDelete);
          this.savedJson.splice(index, 1);

          if (this.savedJson.length == 0) {
            this.noAvailableJsons = true;
          }

          if (`${this.currentFile}.json` == this.jsonToDelete) {
            this.loadClicked('N');
          }

          this.jsonToDelete = '';
        } catch (error) {
          this.popupShow = true;
          this.popupType = 'error';
          this.popupTitle = 'JSON NOT Deleted';
          this.popupContent = `There was an error occurred while deleting ${this.jsonToDelete}, please try again.`;
          this.popupButtons = [];
        }
      }
    },

    loadClicked: async function(state) {
      this.noAvailableJsons = false;
      this.savedJson = [];

      if (state == 'L') {
        this.showSavedJsons = true;
        this.loadingJsons = true;

        try {
          let data = await this.$apiCallV2('/LOI/GetAvailableFiles');
          if (data.length == 0) {
            this.noAvailableJsons = true;
          } else {
            this.savedJson = data.map(d => {
              let name = d.split('\\');
              return name[name.length - 1];
            });
          }
        } catch (e) {
          this.noAvailableJsons = true;
        }

        this.loadingJsons = false;
      } else if (state == 'N') {
        this.textLists = [];
        this.mainStyleObj['padding-top'] = '150';
        this.mainStyleObj['padding-right'] = '30';
        this.mainStyleObj['padding-bottom'] = '50';
        this.mainStyleObj['padding-left'] = '30';

        this.currentFile = 'Untitled';
      } else if (state == 'C') {
        this.showSavedJsons = false;
      }
    },
    loadJson: async function(name) {
      this.showSavedJsons = false;
      let loadedJson = await this.$apiCallV2(`/LOI/GetJson?file=${name}`);

      let loadedMain = loadedJson['mainStyle'];
      this.mainStyleObj = this.cssStringToObject(loadedMain, true);

      this.textLists = this.convertLoadedDataToView(loadedJson['data']);
      this.currentFile = name.split('.json').join('');
    },
    deleteJsonClicked: function(index) {
      this.jsonToDelete = this.savedJson[index];

      this.popupShow = true;
      this.popupType = 'warning';
      this.popupTitle = 'Delete JSON';
      this.popupContent = `Are you sure you want to delete the LOI JSON format for ${this.jsonToDelete}?`;
      this.popupButtons = [
        { color: 'red', text: 'Delete', textColor: 'white' },
        { color: 'gray', text: 'Cancel', textColor: 'white' }
      ];
    },
    cssStringToObject: function(css, main) {
      let cssObj = {};

      let allCss = css.split(';');
      allCss.forEach(a => {
        if (a) {
          let key = a.split(':')[0].trim();
          let val = a.split(':')[1].trim();
          if (this.addPXKey.includes(key)) { cssObj[key] = val.split('px').join('') }
          else if (key == 'height' && main) { cssObj['height'] = 'calc(100%)' }
          else { cssObj[key] = val }
        }
      });
      
      return cssObj;
    },
    convertLoadedDataToView: function(data) {
      let res = data.map(d => {
        let returnObj = {};
        if (d['styleObj']) {
          return d;
          // if (d['child']) {
          //   let childCss = this.cssStringToObject(d['child'][0]['style']);
          //   if (childCss['min-width']) {
          //     childCss['min-width'] = parseInt(childCss['min-width']) / 1.2;
          //   }

          //   d['child'][0]['style'] = Object.entries(childCss).map(([k, v]) => `${k}:${v}${this.addPXKey.includes(k) ? 'px' : ''}`).join(';');
          //   d['child'][0]['styleObj'] = childCss;
          //   return d;
          // } else {
          //   return d;
          // }
        } else {
          let css = this.cssStringToObject(d['style'], false);
          returnObj['text'] = d['text'];
          returnObj['style'] = d['style'];
          returnObj['styleObj'] = {
            'margin-top': css['margin-top'] ? css['margin-top'] : 0,
            'margin-right': css['margin-right'] ? css['margin-right'] : 0,
            'margin-bottom': css['margin-bottom'] ? css['margin-bottom'] : 0,
            'margin-left': css['margin-left'] ? css['margin-left'] : 0
          };
          if (d['child']) {
            returnObj['style'] = '';
            returnObj['child'] = d['child'].map(c => {
              return {
                'text': c['text'],
                'style': c['style'],
                'styleObj': this.cssStringToObject(c['style'], false)
              }
            });
          }
        }

        return returnObj;
      });
      
      return res;
    }
  },
  mounted() {
    // this.screenDPI = this.$refs['testdiv'].offsetWidth;
    // this.a4height = Math.round(this.a4height / 300 * this.screenDPI);
    // this.a4width = Math.round(this.a4width / 300 * this.screenDPI);

    this.rightSection = this.$refs['right-section'];
    // let bound = this.rightSection.getBoundingClientRect();

    // let viewWidth = bound.height / a4Ratio;
    // this.rightSection.style.minWidth = `${viewWidth}px`;
    // this.rightSection.style.maxWidth = `${viewWidth}px`;

    // this.viewRatio = Math.round(viewWidth / this.a4width * 10000) / 10000;
    // this.viewFont = a4Font * this.viewRatio;

    // this.rightSection.style.fontSize = `${this.viewFont}px`;

    // this.viewFont = a4Font * this.viewRatio;

    // console.log(bound.height / bound.width);

    // this.rightSection.style.fontSize = `${this.viewFont}px`;
    // console.log(this.viewRatio, this.viewFont);
    
    this.a4Container = this.rightSection.children[0];
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.create-loi-main {
  display: flex;
  height: 100%;
  width: 100%;
  padding: 5px;
  font-size: 12px;

  > .left-section, > .right-section {
    height: 100%;
    background-color: white;
  }

  > .left-section {
    padding: 5px;
    border-radius: 5px;
    min-width: 300px;
    max-width: 300px;
    margin-right: 5px;
    display: flex;
    flex-direction: column;

    > .current-name {
      width: 100%;
      font-weight: bold;
      padding: 5px;
      text-align: center;
    }

    > .all-texts {
      width: 100%;
      overflow: auto;
      height: 100%;
      margin: 5px 0;

      > .text-holder {
        width: 100%;
        border: 1px solid gray;
        margin: 5px 0;
        padding: 5px;

        > .text-buttons {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 5px;

          > button {
            margin-left: 5px;
          }

          > .delete {
            color: white;
            background-color: red;
          }
        }
      }
    }

    > .saved-json {
      height: 100%;
      overflow: auto;

      > .title {
        padding: 5px;
        width: 100%;
        text-align: center;
        font-weight: bold;
      }

      > .jsons {
        border: 1px solid gray;
        margin-bottom: 3px;
        cursor: pointer;
        display: flex;
        align-items: center;
        position: relative;

        > div {
          width: 100%;
          height: 100%;
          padding: 5px;
        }
        
        &:hover {
          background-color: rgba(0,0,0,0.5);
          color: white;
        }

        > .delete {
          position: absolute;
          right: 5px;
          height: 80%;
        }
      }
    }
  }
  
  > .show-save {
    position: fixed;
    background-color: rgba(0,0,0,0.3);
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;

    > .content {
      padding: 5px;
      background-color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      min-width: 450px;
      max-width: 450px;

      > .title {
        padding: 10px;
        font-weight: bold;
        width: 100%;
        text-align: center;
      }

      > .close {
        position: absolute;
        right: 5px;
        top: 5px;
        cursor: pointer;
        height: 20px;
        width: 20px;
      }
    }
  }

  > .right-section {
    overflow: auto;
    min-width: 210mm;
    height: 100%;

    > * {
      font-family: Arial, Helvetica, sans-serif !important;
    }
  }

  > .right-toolbar {
    background-color: white;
    max-width: 50px;
    min-width: 50px;
    border-radius: 5px;
    margin-left: 5px;
    padding: 5px;

    > button {
      width: 100%;
      margin-bottom: 5px;
    }
  }
}

.left-button {
  width: 100%;
  margin-bottom: 3px;
}

input {
  width: 100%;
}

textarea {
  width: 100%;
  resize: none;
  min-height: 75px;

  &:focus {
    outline: none;
  }
}

.styling-button {
  > input {
    width: 50px;
  }
}

.text-container {
  white-space: pre-wrap;

  > input {
    width: 50px;
  }
}
</style>

<style>
.holder {
  height: 297mm;
  width: 210mm;
  max-height: 297mm;
  min-height: 297mm;
  max-width: 210mm;
  min-width: 210mm;
  font-size: 14px;
  line-height: 1.3em;
  border: 1px solid gray;
}
</style>